module.exports = __webpack_public_path__ + "../resources/images/illustration_balloon-e0ea44b6416393731b25f8229ef4e2e8.svg";